import {HomeI18n} from '@/locales/base.message.locales';
import {about} from '@/locales/en/about.locale';
import {partners} from '@/locales/en/partners.locale';
import {howItWorks} from '@/locales/en/how-it-works.locale';
import {ideasPlace} from '@/locales/en/ideas-place.locale';

export const home: HomeI18n = {
  title: 'Because complex social problems are too big to solve alone',
  subtitle: 'We\'ve created a league',
  lives_impacted: 'Lives impacted<br/> by our challenges<br/> and solutions around<br/> the world',
  impact_board: {
    title: 'Social Impact Board',
    button: 'MEET THE LEAGUE',
    loading_members: 'Loading impact board members...'
  },
  about,
  partners,
  how_it_works: howItWorks,
  ideas_place: ideasPlace,
  header: {
    text: `WE\'VE CREATED A LEAGUE BECAUSE COMPLEX SOCIAL PROBLEMS ARE TOO BIG TO SOLVE ALONE`,
    sub_text: 'Because complex social problems</br> are too big to solve alone',
    title: 'IKONE unlocks the power of synergy connecting problems to solvers through an open innovation challenge platform',
    video: 'Watch the video'
  },
};
